import styled from 'styled-components'

type TypeTitle ={
    text?:string
    color?: string
}

type TypeColor = {
  color:string
}

export const CategoriesContainer = styled.div`
    display: grid;
    grid-template-columns: 1fr 1fr 1fr;
    grid-auto-rows: 31.90vw;
    @media (max-width: ${props => props.theme.breakpoints.md}){
      grid-template-columns: none;
      grid-auto-rows: 1fr;    
    }   
`

export const ShowMoreButton = styled.button<TypeColor>`
      border-radius:6px;
      border:none;
      width: 220px;
      height: 60px;
      font-weight:700;
      color:#FFFFFF;
      line-height:21.79px;
      font-size:16px;
      cursor:pointer;
      background-color:${(props) =>`${props.color}`};
      @media (max-width: ${props => props.theme.breakpoints.md}){
        width:130px;
        height:35.45px;
      }
`

export const ShowMoreButtonContainer = styled.div`
      display:flex;
      justify-content: center;
      @media (max-width: ${props => props.theme.breakpoints.md}){
        padding-bottom: 40px;
      }
      z-index: 99999;
      & > {
        z-index: 99999;
      }
`

export const ImgHoverZoom = styled.div`
    overflow: hidden;
    & > img {
        transition: transform .5s ease;
        height: 22.3vw;
        width: 100%;
        object-fit: cover;
        @media (max-width: ${props => props.theme.breakpoints.md}){
           height: 50px;
           width: 50px;
           border-radius: 6px;            
        } 
    }
`

export const CategoryName = styled.div<TypeTitle> `
    font-style: normal;
    font-weight: 700;
    line-height: 27px;
    color: #222222 ;
    font-size: 20px;
    display:flex;
    justify-content:center;
    &:after{
        content:${(props) =>`"${props.text}"`}
    }
    @media (max-width: ${props => props.theme.breakpoints.md}){
           align-items: center;
           padding-left: 20px;
    } 
    
`

export const CardCategory = styled.div<TypeTitle>` 
    margin:2.8vw;
    display:flex;
    flex-direction:column;
    justify-content:space-between;
    cursor:pointer;
    &:hover > ${ImgHoverZoom} > img{
        transform: scale(1.5);
    }
    &:hover > ${CategoryName} {
        color:${(props) =>`${props.color}`}
    }
    @media (max-width: ${props => props.theme.breakpoints.md}){
      flex-direction:row;
      justify-content:flex-start;      
    }  
`

export const Breadcrumbs = styled.ul`
  list-style: none;
  padding-left: 100px;
  & > li:after {
    color: #999999;
    content: "/";
    padding: 0 8px;;
  }
`

export const Crumb = styled.li`
  display: inline-block;
  color:#000000;
  font-weight: 700;
  font-style: normal;
  font-size: 16px;
  line-height: 21.79px;
  &:last-of-type:after {
    content: "";
    padding: 0;
  }

  a {
    color: #999999;
    font-weight: 400;
    text-decoration: none;
    cursor:pointer;
    &:hover,
    &:active {
      text-decoration: underline;
    }
  }
`;
